import {get} from 'lodash';
import gql from 'graphql-tag';
import {useQuery} from '@apollo/react-hooks';

const CARDS_MIN_LIMIT = 3;

const flexibleDatesListingQuery = gql`
    query flexibleDatesListingQuery(
        $request: SearchResultRequest!
        $currentResults: [String]!
    ) {
        flexibleDateListings(
            request: $request
            currentResults: $currentResults
        ) {
            averageRating
            bedrooms
            detailPageUrl
            listingId
            listingRequestParams {
                arrival
                departure
            }
            propertyMetadata {
                headline
            }
            headlinePhoto(treatment: C4) {
                uri
            }
            photos(treatment: C4) {
                uri
            }
            sleeps
            averagePrice {
                value
            }
            priceSummary {
                formattedAmount
                pricePeriodDescription
            }
            spaces {
                bathrooms {
                    capacity
                }
            }
            reviewCount
        }
    }
`;

export const useFetchFlexDatesCarouselListings = (
    searchParams,
    searchResults,
    skipQuery
) => {
    const listings = get(searchResults, ['listings'], []);
    const resultCount = get(searchResults, ['resultCount'], 0);
    const {dates: {arrivalDate, departureDate} = {}} = searchParams;
    const hasDates = !!(arrivalDate && departureDate);
    const {data, loading} = useQuery(flexibleDatesListingQuery, {
        skip: skipQuery || !hasDates || resultCount >= 50,
        errorPolicy: 'ignore',
        variables: {
            request: {
                ...searchParams,
                paging: {
                    page: 1,
                    pageSize: 20
                }
            },
            currentResults: listings.map(
                ({listingNumber}) => `${listingNumber}`
            )
        }
    });

    const flexibleDateListings = get(data, ['flexibleDateListings'], []);

    if (flexibleDateListings.length < CARDS_MIN_LIMIT) {
        return {
            flexibleDateListings: [],
            flexibleDateListingsLoading: loading
        };
    }

    return {flexibleDateListings, flexibleDateListingsLoading: loading};
};
